export function formatStreetCityQuery(streetName, city) {
  const street = String(streetName ?? "").trim();
  const cityName = String(city ?? "").trim();
  if (!street || !cityName) return "";
  return `${street}, ${cityName}`;
}

export function getExistingStreetCity(fields = {}) {
  const streetName = String(
    fields.streetName ?? fields.street ?? fields.addrStreet ?? "",
  ).trim();
  const city = String(
    fields.city ?? fields.addrCity ?? fields.City ?? "",
  ).trim();
  if (!streetName || !city) return null;
  return {
    streetName,
    city,
    query: formatStreetCityQuery(streetName, city),
  };
}

export function parseAddressFromPlace(place) {
  const components = place.address_components || [];
  const find = (...types) => {
    for (const type of types) {
      const comp = components.find((c) => c.types.includes(type));
      if (comp) return comp.long_name;
    }
    return "";
  };

  return {
    streetName: find("route"),
    streetNumber: find("street_number"),
    city: find("locality", "administrative_area_level_2", "sublocality"),
    zipCode: find("postal_code"),
  };
}
